import(/* webpackMode: "eager" */ "/root/lp-frontend/public/blogImg/blogImg.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/lp-frontend/src/app/[lang]/blog/blogList.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/lp-frontend/src/app/[lang]/browsecourses/SearchAll.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["Layout","ContentContainer","OurBlogContainer","Avtar","Heading","TP"] */ "/root/lp-frontend/src/components/molecules/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/lp-frontend/src/components/NoResult.jsx");
